var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-top bg-light p-3"},[_c('b-nav',{attrs:{"align":"center"}},[_c('b-nav-item',{attrs:{"href":"/terms.html"}},[_vm._v(_vm._s(_vm.$t("general.terms")))]),_c('b-nav-item',{attrs:{"href":"/privacy.html"}},[_vm._v(_vm._s(_vm.$t("general.privacy")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }